import { Storage } from './storage';

const DEVICE_ID_KEY = '__metric_device_id__';

/**
 * 生成 UUID v4
 */
function generateUUID(): string {
  // 使用 crypto.randomUUID() 如果可用
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  // 备用方案：使用传统方式生成 UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 获取或生成设备ID
 * 首次访问时生成 UUID 并存储到 localStorage
 * 后续访问从 localStorage 读取
 */
export function getOrCreateDeviceId(): string {
  // 尝试从 localStorage 读取
  const existingId = Storage.get(DEVICE_ID_KEY);
  if (existingId) {
    return existingId;
  }

  // 生成新的设备ID
  const newDeviceId = generateUUID();
  
  // 存储到 localStorage
  Storage.set(DEVICE_ID_KEY, newDeviceId);

  return newDeviceId;
}

/**
 * 清除设备ID（用于测试或重置）
 */
export function clearDeviceId(): void {
  Storage.remove(DEVICE_ID_KEY);
}
